import cleanedFilename from '~/util/cleanedFilename';

export default {
  YES_PATH_BUTTON: `${cleanedFilename(__filename)}-yes-path-button`,
  NO_PATH_BUTTON: `${cleanedFilename(__filename)}-no-path-button`,
};
